import apiClient from "./axios"

export const getPrayerSchedule = async (params = {}) => {
  const { data } = await apiClient.get("/prayer-times", { params })
  return data
}
